/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import { isObject } from 'lodash';
import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  filterData: {
    isEdit: false,
    isFilter: true,
    batchesForPayee: null,
    detailScreenObj: {},
    filterBatchesBy: 'noFilter',
    batchFromDate: null,
    batchToDate: null,
    batchCCN: null,
    batchNumber: null,
    batchCompleteStatus: null,
    batchInCompleteStatus: 'I',
  },
  checkPayee: [],
  logBatchList: [],
  logBatchDetail: {},
  logBatchHistory: [],
  logCheckDetails: {},
  errorMessagesInRedux: {},
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_LOG_BATCH_FILTER_DATA:
      return { ...state, filterData: action.filterData };
    case actionTypes.GET_CHECK_PAYEE_LIST:
      return { ...state, checkPayee: action.checkPayee };
    case actionTypes.GET_LOG_BATCH_TOTAL_LIST:
      return { ...state, logBatchList: action.logBatchList };
    case actionTypes.GET_LOG_BATCH_TOTAL_DETAIL:
      return { ...state, logBatchDetail: action.logBatchDetail };
    case actionTypes.GET_LOG_BATCH_TOTAL_HISTORY:
      return { ...state, logBatchHistory: action.logBatchHistory };
    case actionTypes.GET_LOG_NUMBER_DETAILS:
      return { ...state, logCheckDetails: action.logCheckDetails };
    case actionTypes.SAVE_STATUS:
      return { ...state, saveStatus: action.saveStatus };
    case actionTypes.HANDLE_ERROR_MSG:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionTypes.DETAIL_SCREEN_OBJ:
      return { ...state, detailScreenObj: action.detailScreenObj };
    default:
      return state;
  }
};

export default reducer;
